import {
    TAG_BRANDING_GUIDELINES,
    TAG_BROCHURES,
    TAG_BUSINESS_CARDS,
    TAG_COLORS_FONTS,
    TAG_LOGO,
    TAG_OFFLINE,
    TAG_ONLINE,
    TAG_PRODUCT_LABEL,
    TAG_PRODUCT_PACKAGING,
    TAG_SIGNAGE,
    TAG_SOCIAL_MEDIA,
    TAG_STATIONARY,
    TAG_WEBSITE,
} from './constants';

export function recommend(filterTags: FilterTags) {
    return recommendedBrandingProducts(brandingProductsWithTags, filterTags).slice(0, 4);
}

export interface FilterTags {
    [key: string]: boolean;
}

interface BrandingProductsWithTags {
    [key: string]: string[];
}

const tagWeights: { [key: string]: number } = {
    [TAG_LOGO]: 3,
    [TAG_COLORS_FONTS]: 2,
    [TAG_WEBSITE]: 2,
    [TAG_SOCIAL_MEDIA]: 2,
    [TAG_STATIONARY]: 2,
    [TAG_PRODUCT_PACKAGING]: 2,
    [TAG_SIGNAGE]: 2,
    [TAG_PRODUCT_LABEL]: 2,
    [TAG_BUSINESS_CARDS]: 2,
    [TAG_BROCHURES]: 2,
    [TAG_BRANDING_GUIDELINES]: 2,
    [TAG_ONLINE]: 1,
    [TAG_OFFLINE]: 1,
};

const brandingProductsWithTags: BrandingProductsWithTags = {
    'logo-brand-identity-pack': [
        TAG_LOGO,
        TAG_STATIONARY,
        TAG_BUSINESS_CARDS,
        TAG_SOCIAL_MEDIA,
        TAG_ONLINE,
        TAG_OFFLINE,
    ],
    'logo-website-squarespace': [TAG_LOGO, TAG_ONLINE, TAG_WEBSITE],
    'logo-brand-guide': [
        TAG_LOGO,
        TAG_COLORS_FONTS,
        TAG_BRANDING_GUIDELINES,
        TAG_ONLINE,
        TAG_OFFLINE,
    ],
    'brand-guide': [TAG_COLORS_FONTS, TAG_BRANDING_GUIDELINES],
    'logo-design': [TAG_LOGO, TAG_ONLINE, TAG_OFFLINE],
    'logo-social-media-pack': [TAG_LOGO, TAG_ONLINE, TAG_SOCIAL_MEDIA],
    'logo-business-card-design': [TAG_LOGO, TAG_OFFLINE, TAG_BUSINESS_CARDS],
    'squarespace-web-commerce': [TAG_ONLINE, TAG_WEBSITE],
    'facebook-creative': [TAG_ONLINE, TAG_SOCIAL_MEDIA],
    'business-card-design': [TAG_OFFLINE, TAG_BUSINESS_CARDS],
    'product-packaging-design': [TAG_PRODUCT_PACKAGING, TAG_ONLINE, TAG_OFFLINE],
    'product-label-design': [TAG_PRODUCT_LABEL, TAG_ONLINE, TAG_OFFLINE],
    'brochure-design': [TAG_OFFLINE, TAG_BROCHURES],
    'signage-design': [TAG_OFFLINE, TAG_SIGNAGE],
};

function recommendedBrandingProducts(
    brandingProductsWithTags: BrandingProductsWithTags,
    filterTags: FilterTags
) {
    const productKeysWithWeighting: { [key: string]: number } = Object.keys(
        brandingProductsWithTags
    ).reduce(
        (products, product) => ({
            ...products,
            [product]: 0,
        }),
        {}
    );

    const addWeight = (productKey: string, tag: string) => {
        productKeysWithWeighting[productKey] += tagWeights[tag];
    };

    const filterTagKeyValues = Object.entries(filterTags);

    Object.entries(brandingProductsWithTags).forEach(([productKey, productTags]) => {
        filterTagKeyValues.forEach(([filterTag, value]) => {
            const productIncludesTag = productTags.includes(filterTag);

            if ((value && productIncludesTag) || (!value && !productIncludesTag)) {
                addWeight(productKey, filterTag);
            }
        });
    });

    const sortedProductKeysByWeighting = Object.entries(productKeysWithWeighting).sort(
        (a, b) => b[1] - a[1]
    );

    return sortedProductKeysByWeighting.map((product) => product[0]);
}
